/*
 * @Author: zl
 * @Date: 2021-11-22 17:04:18
 * @LastEditTime: 2022-02-22 08:43:16
 * @LastEditors: zl
 * @Description: 描述： 报表管理
 */
import request from '../request.js'

/**
 * 描述： 报表管理--审计任务委托报表
 * author：崔北超
 * 
 */
export const selectAuditTaskDelegationReport = function (data) {
    return request({
        url: '/busTask/selectAuditTaskDelegationReport',
        method: 'post',
        data
    })
}

/**
 * 描述： 报表管理--获取季度下拉框填充值
 * author：崔北超
 * 
 */
export const getQuarterData = function (data) {
    return request({
        url: '/busTask/getQuarterData',
        method: 'post',
        data
    })
}

/**
 * 描述： 获取个人自定义列过滤数据
 * author： 郑志会
 * 
 */
export const getSelfData = function (data) {
    return request({
        url: '/opeSelfColumns/getSelfData',
        method: 'post',
        data
    })
}

/**
 * 描述： 保存个人自定义列过滤数据
 * author： 郑志会
 * 
 */
export const saveSelfColumns = function (data) {
    return request({
        url: '/opeSelfColumns/saveSelfColumns',
        method: 'post',
        data
    })
}


/**
 * 描述： 县区统计
 * author： 崔北超
 * 
 */
export const getCountyData = function (data) {
    return request({
        url: 'auditPlanValue/countyAndDistrictStatistics',
        method: 'post',
        data
    })
}

/**
 * 描述： 项目统计
 * author： 崔北超
 * 
 */
export const getProjectData = function (data) {
    return request({
        url: '/auditoutputvalue/selectProjectExamineOutput',
        method: 'post',
        data
    })
}

/**
 * 描述： 获取建设单位
 * author： 崔北超
 * {"limitId":"1382233551767498754"}
 */
export const getUnit = function (data) {
    return request({
        url: 'sysLimitMenuRange/getMenuRangeLimitId',
        method: 'post',
        data
    })
}

/**
 * 项目统计
 * 查询条件-时间维度-季度
 */
export const getProjectStatisticsQuarter = function (data) {
    return request({
        url: 'auditoutputvalue/getProjectStatisticsQuarter',
        method: 'post',
        data
    })
}

/**
 * 县区统计-折柱图
 * author： 崔北超
 */
export const getCityStatisticsToFoldColumnDiagram = function (data) {
    return request({
        url: '/auditOutputValueStatistics/getCityStatisticsToFoldColumnDiagram',
        method: 'post',
        data
    })
}

/**
 * 县区统计-饼状图
 * author： 崔北超
 */
export const getCityStatisticsToPieChart = function (data) {
    return request({
        url: '/auditOutputValueStatistics/getCityStatisticsToPieChart',
        method: 'post',
        data
    })
}

/**
 * 项目统计-折柱图
 * author： 崔北超
 */
export const getProjectStatisticsToFoldColumnDiagram = function (data) {
    return request({
        url: '/auditOutputValueStatistics/getProjectStatisticsToFoldColumnDiagram',
        method: 'post',
        data
    })
}

/**
 * 项目统计-饼状图
 * author： 崔北超
 */
export const getProjectStatisticsToPieChart = function (data) {
    return request({
        url: '/auditOutputValueStatistics/getProjectStatisticsToPieChart',
        method: 'post',
        data
    })
}

/**
 * 项目统计-饼图-季度获取
 * author： 崔北超
 */
export const getProjectPieQuarter = function (data) {
    return request({
        url: '/auditOutputValueStatistics/getProjectStatisticsQuarter',
        method: 'post',
        data
    })
}
